import React from 'react';
import api from 'api';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.currentUser) {
      nextProps.router.push(nextProps.locationRequested);
    }
  }
  render() {
    return (
      <div className="login-box">
        <div className="login-logo">
          <b>PMS</b>
        </div>
        <div className="login-box-body">
          <p className="login-box-msg">Login</p>
          <form role="form">
            {
              !this.props.params.client_id
                ? <div className="form-group">
                    <input ref="client_id" type="text" placeholder="Client ID" className="form-control" />
                  </div>
                : null
            }
            <div className="form-group">
              <input ref="login" type="text" placeholder="Login" className="form-control" />
            </div>
            <div className="form-group">
              <input ref="password" type="password" placeholder="Password" className="form-control" />
            </div>
            <span className="text-red">{ this.props.error }</span>
            <div className="row">
              <div className="col-xs-8"></div>
              <div className="col-xs-4">
                <button className="btn btn-primary btn-block btn-flat" onClick={ this.handleLogin } disabled={ this.props.logging }>
                  Sign In
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
  handleLogin(event) {
    event.preventDefault();
    const login = this.refs.login.value;
    const password = this.refs.password.value;
    const client_id = this.props.params.client_id || this.refs.client_id.value;
    const url = window.location.hostname.includes('www.') ? window.location.hostname.split('www.')[1] : window.location.hostname;
    const domain_name = url.split('.')[0];
    if (login && password && client_id) {
    // if (login && password) {
      this.props.api.auth.login({ login, password, client_id, domain_name });
    }
  }
}

Login.propTypes = {
  api: React.PropTypes.object,
};

export default api.connect(Login, 'auth', { noClearOnUnmount: true });



// WEBPACK FOOTER //
// ./src/frontend/modules/authentication/containers/Login.jsx